// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hVFU","comment":"styles_comment__3MPEq"};